/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Missing_Dialogue_NameInputs */

const en_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Missing Dialogue 0${i?.index}`)
};

const fr_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dialogue manquant 0${i?.index}`)
};

const de_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlender Dialog 0${i?.index}`)
};

const it_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dialogo mancante 0${i?.index}`)
};

const ru_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отсутствующий диалог 0${i?.index}`)
};

const es_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diálogo faltante 0${i?.index}`)
};

const zh_cn2_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`缺失对话 0${i?.index}`)
};

const ja_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`会話が欠落しています 0${i?.index}`)
};

const hi_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संवाद गायब है 0${i?.index}`)
};

const pt_pt2_missing_dialogue_name = /** @type {(inputs: Missing_Dialogue_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diálogo ausente 0${i?.index}`)
};

/**
* | output |
* | --- |
* | "Missing Dialogue 0{index}" |
*
* @param {Missing_Dialogue_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const missing_dialogue_name = /** @type {((inputs: Missing_Dialogue_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Dialogue_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_missing_dialogue_name(inputs)
	if (locale === "de") return de_missing_dialogue_name(inputs)
	if (locale === "it") return it_missing_dialogue_name(inputs)
	if (locale === "ru") return ru_missing_dialogue_name(inputs)
	if (locale === "es") return es_missing_dialogue_name(inputs)
	if (locale === "zh-CN") return zh_cn2_missing_dialogue_name(inputs)
	if (locale === "ja") return ja_missing_dialogue_name(inputs)
	if (locale === "hi") return hi_missing_dialogue_name(inputs)
	if (locale === "pt-PT") return pt_pt2_missing_dialogue_name(inputs)
	return en_missing_dialogue_name(inputs)
});